import {Form, FormInstance, Select} from 'antd'
import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {useRouteLoaderData} from 'react-router-dom'
import {Project} from '../../../entities/project'
import {useAsyncValue} from '../../../hooks/useAsyncValue'
import {instance as projectsService} from '../../../services/ProjectsService'

export type ElementFormDropdownProps = {
  selectedProjectId: number
  projectsList: {id: number; name: string}[]
  fieldName?: string
  preventFormCloseDueToModification: () => void
}

export function ElementFormDropdown({
  selectedProjectId,
  projectsList,
  fieldName = 'elementId',
  preventFormCloseDueToModification,
}: ElementFormDropdownProps) {
  const intl = useIntl()

  const projectFromRoute =
    (((useRouteLoaderData('project') as any) || {}).project as Project) || undefined

  const {
    value: availableElements,
    isLoading: availableElementsLoading,
    error,
  } = useAsyncValue(
    [],
    async () => {
      const project = projectsList.find((p) => p.id === selectedProjectId)
      if (!project) {
        return []
      }

      if (project.id === projectFromRoute?.id) {
        return projectFromRoute?.elements?.map((e) => ({value: e.elementId, label: e.name})) || []
      }

      const elements = await projectsService.getUserProjectElements(project.id)
      return elements.map((e) => ({value: e.elementId, label: e.name}))
    },
    [selectedProjectId]
  )

  return (
    <Form.Item name={fieldName} label={intl.formatMessage({id: 'element'})}>
      <Select
        loading={availableElementsLoading}
        allowClear
        options={availableElementsLoading ? [] : availableElements}
      ></Select>
    </Form.Item>
  )
}
